import React, { useState } from "react";
import { Modal, message, Tooltip, Button } from "antd";
import { CopyOutlined, CheckOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// Constants
import { digits, allowedKeys } from "../../../constants/data/data-constants";

// API functions
import { ApiHelperFunction } from "../../../helpers/api_helpers";

const initialValues = {
  name: "",
  email: "",
  phone_number: "",
  message: "",
};

const createErrors = {
  name: "",
  email: "",
  phone_number: "",
  message: "",
};

const emailReg =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

interface ContactModalProps {
  open: boolean;
  onCancel: () => void;
  data: any;
}

const ContactModal: React.FC<ContactModalProps> = ({
  open,
  onCancel,
  data,
}) => {
  const [userQuery, setuserQuery] = useState(initialValues);
  const [errors, seterrors] = useState(createErrors);
  const [loading, setLoading] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setuserQuery({ ...userQuery, [e.target.name]: e.target.value });
    seterrors((prev) => ({ ...prev, [e.target.name]: "" }));
  };

  const handleValidation = () => {
    const { name, email, phone_number, message } = userQuery;
    let tempErrors = { ...createErrors };
    let valid = true;

    if (!name) {
      tempErrors.name = "Name is required.";
      valid = false;
    }
    if (!email) {
      tempErrors.email = "Email cannot be empty.";
      valid = false;
    } else if (!emailReg.test(email)) {
      tempErrors.email =
        "Please put email in correct format. E.g., abc@xxx.com";
      valid = false;
    }
    if (
      phone_number &&
      (phone_number.length < 10 || phone_number.length > 15)
    ) {
      tempErrors.phone_number =
        "Phone number must be between 10 to 15 integers.";
      valid = false;
    }
    if (!message || message.length < 5) {
      tempErrors.message = "Message cannot be less than 5 characters.";
      valid = false;
    }
    seterrors(tempErrors);
    return valid;
  };

  const handleSubmit = async (e?: React.MouseEvent<HTMLDivElement>) => {
    if (e) e.preventDefault();
    if (loading) return;
    if (!handleValidation()) return;

    setLoading(true);
    try {
      let bodyData = { data: userQuery };
      let response = await ApiHelperFunction({
        urlPath: "/contact-us-form-submissions",
        method: "POST",
        data: bodyData,
      });

      console.log(response);

      if (response.data?.data) {
        message.success("Successfully submitted your query.");
        setuserQuery(initialValues);
        seterrors(createErrors);
        onCancel();
      } else {
        message.error("Failed to submit your query.");
      }
    } catch {
      message.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = () => {
    const couponCode = data?.attributes?.coupon_code || "FESTIVE20";
    navigator.clipboard.writeText(couponCode);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 1000);
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={800}
      destroyOnClose
      title={null}
      className="contact-modal"
    >
      <div className="row">
        <div className="col-lg-6 mb-5 mb-lg-0">
          <div className="onloading-modal-left">
            <img
              src="assets/images/logo-icon.svg"
              alt="Logo"
              className="onloadingmodal-logo"
            />
            <h2>
              Get your first assignment <span>Free</span>
            </h2>
          </div>
        </div>
        <div className="col-lg-6">
          {/* Your custom form structure */}
          <div className="cntcus-form home-banner-form">
            <div className="cntcus-hdng">
              <h4 className="text-start">Submit Your Query</h4>
            </div>
            <form>
              <div className="row gy-4">
                <div className="col-12">
                  <div className="form-group">
                    <div className="form-group-icon">
                      <img src="assets/images/name-ico.svg" alt="name-ico" />
                    </div>
                    <div className="form-group-form">
                      <input
                        type="text"
                        name="name"
                        value={userQuery.name}
                        placeholder="Name"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <span className="text-danger text-errr">{errors.name}</span>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <div className="form-group-icon">
                      <img src="assets/images/email-ico.svg" alt="email-ico" />
                    </div>
                    <div className="form-group-form">
                      <input
                        type="email"
                        name="email"
                        value={userQuery.email}
                        placeholder="Email"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <span className="text-danger text-errr">{errors.email}</span>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <div className="form-group-icon">
                      <img src="assets/images/phone-ico.svg" alt="phone-ico" />
                    </div>
                    <div className="form-group-form">                      <PhoneInput
                        enableSearch
                        country={"gb"}
                        countryCodeEditable={false}
                        preferredCountries={["in", "gb"]}
                        value={userQuery.phone_number}
                        placeholder="Phone Number"
                        onChange={(phone) => {
                          setuserQuery((prev) => ({
                            ...prev,
                            phone_number: phone,
                          }));
                          seterrors((prev) => ({ ...prev, phone_number: "" }));
                        }}
                        inputProps={{
                          required: true,
                        }}
                        inputStyle={{
                          width: "100%",
                          height: "45px",
                          fontSize: "14px",
                          padding: "10px 10px 10px 48px",
                          border: "none",
                          borderRadius: "0",
                        }}
                        buttonStyle={{
                          border: "none",
                          borderRadius: "0",
                          background: "transparent",
                        }}
                        dropdownStyle={{
                          width: "300px",
                        }}
                        searchStyle={{
                          width: "90%",
                          height: "30px",
                          margin: "0 auto",
                          padding: "5px",
                        }}
                      />
                    </div>
                  </div>
                  <span className="text-danger text-errr">
                    {errors.phone_number}
                  </span>
                </div>
                <div className="col-xl-12">
                  <div className="form-group form-group-textarea">
                    <div className="form-group-icon">
                      <img
                        src="assets/images/subject-ico.svg"
                        alt="subject-ico"
                      />
                    </div>
                    <div className="form-group-form">
                      <textarea
                        name="message"
                        value={userQuery.message}
                        placeholder="Write your Description"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <span className="text-danger text-errr">
                    {errors.message}
                  </span>
                </div>
                <div className="col-xl-12">
                  <div className="btn-group" onClick={handleSubmit}>
                    <a
                      href="#!"
                      className="custombtn btn-1 hover-filled-slide-down"
                      style={{
                        pointerEvents: loading ? "none" : "auto",
                        opacity: loading ? 0.5 : 1,
                      }}
                    >
                      <span>{loading ? "Submitting..." : "Submit"}</span>
                    </a>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ContactModal;
